import React, { useState, useEffect } from 'react';
import '../../css/status.css';

function Status(props) {

  const { bgcolor, completed, onReset } = props;
  const safeCompleted = Number.isFinite(completed) ? completed : 0;

  const fillerStyles = {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    width: `${safeCompleted}%`,
    backgroundColor: bgcolor,
    borderRadius: 'inherit',
    boxShadow: '5px 0px 2px #2E333E',
    overflow: 'hidden',
  }

  const filledLabelStyles = {
    clipPath: `inset(0 ${100 - safeCompleted}% 0 0)`,
  };

  const handleClick = () => {
    if (onReset) onReset();
  };

  return (
    <div id="containerStyles" onClick={handleClick} title="Click to reset progress">
      <div style={fillerStyles} />
      <span className="progress-label base">{`${safeCompleted}%`}</span>
      <span className="progress-label filled" style={filledLabelStyles}>{`${safeCompleted}%`}</span>
    </div>
  );
};

export default Status;
